export default {
  my_selection: 'My selection',
  books: 'Books',
  no_books: 'No books',
  no_books_text: 'There are no books in your selection.',
  illustrations: 'Illustrations',
  no_illustrations: 'No illustrations',
  no_illustrations_text: 'There are no illustrations in your selection.',
  delete_all: 'Delete all',
  close: 'Close',
  open_in_mirador: 'Open in Mirador',
}
